import { useState, useEffect, useCallback } from 'react';
import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import {useMsal} from "@azure/msal-react";
import {apiTokenScopes, authConfig} from "../authConfig";

const useAcquiredToken = () => {
    const [accessToken, setAccessToken] = useState<string | null>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>();

    const { instance:msalInstance, inProgress } = useMsal();

    const acquireToken = useCallback(async () => {
        setLoading(true);
        setError(null);

        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
            setError('No accounts found. User needs to sign in.');
            setLoading(false);
            return;
        }

        const request = {
            ...authConfig,
            scopes: apiTokenScopes.scopes, // Add required scopes here
            account: accounts[0],
        };

        try {
            const response = await msalInstance.acquireTokenSilent(request);
            setAccessToken(response.accessToken);
            setLoading(false);
        } catch (err:any) {
            if (err instanceof InteractionRequiredAuthError) {
                // Interaction required: handle it accordingly (e.g., redirect login)
                await msalInstance.loginRedirect({ scopes: apiTokenScopes.scopes });
            } else {
                setError('Failed to acquire token silently: ' + err.message);
                setLoading(false);
            }
        }
    }, []);

    useEffect(() => {
        acquireToken();
    }, [acquireToken]);

    return { accessToken, loading, error, acquireToken };
};

export default useAcquiredToken;
